module.exports = __webpack_public_path__ + "img/202306_05.018ede11.jpg";